import { aQ as b, S as B, aX as C, aV as d, aW as I, a$ as O, a_ as T, aY as V, aZ as _, aU as f, aT as x, aR as y, aS as E } from "./SkeletonHeader-372f7898.mjs";
import { s as H } from "./styleSkeleton-2bed7b95.mjs";
import "@emotion/react/jsx-runtime";
import "@inflearn/ds-react";
import "react";
import "react/jsx-runtime";
import "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/ko";
import "dayjs/plugin/localizedFormat";
import "dayjs/plugin/updateLocale";
import "@emotion/react";
import "./courseSchema-f9a52331.mjs";
import "@tanstack/react-query";
import "@inflearn/datasource-rest";
import "@mantine/core";
import "@inflearn/analytics";
import "@mantine/hooks";
export {
  b as SNAPSHOT_COOKIE_KEY,
  B as SkeletonHeader,
  C as applyAppShellStateToDocument,
  d as getAttributeAsBoolean,
  I as getAttributeAsString,
  O as getSelectedMenuInSearchBar,
  T as isActiveMenu,
  V as isVisibleSearchBar,
  _ as isVisibleSearchBarWithParams,
  f as makeAppShellStateFromCookies,
  x as makeAppShellStateFromSnapshot,
  y as parseCookieString,
  E as readCookiesIso,
  H as styleSkeleton
};
